import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import styles from './Tabs.module.scss';
import Tab from './Tab';
import * as listActions from '../../listActions';
import { RootState } from 'MyTypes';
import {
    activeCTIndexSelector,
    curriculumTypesSelector,
} from '../../../AppConfig/appConfigSelectors';

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            handleSetActiveTab: listActions.setActiveSlugUsingIndex,
        },
        dispatch,
    );

const mapStateToProps = (state: RootState) => ({
    curriculumTypes: curriculumTypesSelector(state),
    activeCTIndex: activeCTIndexSelector(state),
});

type Props = ReturnType<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>;

const Tabs: React.FC<Props> = ({
    curriculumTypes,
    activeCTIndex,
    handleSetActiveTab,
}) => {
    return (
        <div className={styles.TabContainer}>
            <nav className={styles.Tabs}>
                {curriculumTypes.map(({ displayName, index }) => {
                    return (
                        <Tab
                            key={displayName}
                            index={index}
                            label={displayName}
                            isActiveTab={index == activeCTIndex}
                            handleClick={handleSetActiveTab}
                        />
                    );
                })}
            </nav>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);
